import { Observable, EMPTY as EMPTY_OBSERVABLE } from 'rxjs'
import processSuggestionData from '@aytm/app/stats/lib/draft-js/autocompletePlugin/lib/process-suggestion-data'

const clusterTokenType = 'STR'
const insertAfterToken = 'IN_SHAPE'

export default function createClusterSuggestion(
  _,
  __,
  {
    dependencies: {
      aytmLogic: { clusters },
      parserResult
    }
  }
) {
  if (!clusters || !clusters.length || !parserResult) {
    return EMPTY_OBSERVABLE
  }

  const {
    tokens: { expected, type },
    text: { nonParsed }
  } = parserResult

  if ((expected.last && !expected.last.includes(clusterTokenType)) || type.last !== insertAfterToken) {
    return EMPTY_OBSERVABLE
  }

  const transformToSuggestion =
    ({ canBeCompleted, parserResult }) =>
    value => {
      const token = clusterTokenType
      const label = '"' + value.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&') + '"'

      return processSuggestionData('value', { canBeCompleted, token, label, parserResult })
    }

  return new Observable(observer => {
    const canBeCompleted = Boolean(nonParsed)

    clusters
      .map(transformToSuggestion({ canBeCompleted, parserResult }))
      .filter(suggestion => suggestion)
      .forEach(suggestion => observer.next(suggestion))

    observer.complete()
  })
}
